import { AfterViewInit, Component, ElementRef, Inject, Injector, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { runAfterHydration } from '../shared/run-after-hydration';
import { initPageScrollReveal } from '../shared/scroll-reveal.util';

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.scss'
})
export class TermsOfServiceComponent implements AfterViewInit, OnDestroy {
  @ViewChild('legalRoot') legalRoot!: ElementRef<HTMLElement>;

  private cleanups: Array<() => void> = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private injector: Injector
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      runAfterHydration(this.injector, () => void this.setupScrollRevealAnimation());
    }
  }

  ngOnDestroy(): void {
    this.cleanups.forEach((cleanup) => cleanup());
    this.cleanups = [];
  }

  private async setupScrollRevealAnimation(): Promise<void> {
    const root = this.legalRoot?.nativeElement;
    if (!root) return;
    await initPageScrollReveal(root, this.cleanups);
  }
}
